var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"image",style:({ 'width': _vm.maxWidth + 'px' }),attrs:{"src":(_vm.api + "/paste/" + (this.code) + "/raw"),"alt":"image"},on:{"click":_vm.openRaw}})])}
var staticRenderFns = []

export { render, staticRenderFns }